import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { Channel, GoonAPIClient } from '../client/ApiClient';
import { API_ENDPOINT } from '../constants';

@customElement('channel-page')
export class ChannelPage extends LitElement {
  createRenderRoot() { return this }

  @property() channelSlug = '';
  @state() channel: null | Channel = null;

  async connectedCallback() {
    super.connectedCallback();
    const api = new GoonAPIClient(API_ENDPOINT);
    const chan = await api.getChannelBySlug(this.channelSlug)
    if (chan) {
      this.channel = chan

      document.querySelector('title').text = chan.name
      document.querySelector('meta[name="description"]').text = `Explore top posts in ${chan.name}`
    }
  }

  render() {
    return this.channel ? html`
      <div class="bg-base-100 min-h-screen flex flex-col">
        <!-- Header -->
        <auth-provider>
          <app-header></app-header>
        </auth-provider>

        <!-- Main Content Area -->
        <auth-provider>
          <channel-feed
            .channelSlug=${this.channel.slug}
            .channelId=${this.channel.id}
            channelName=${this.channel.name}
            channelImageUrl=${this.channel.image_url}
          ></channel-feed>
        </auth-provider>

      </div>

      <auth-modal></auth-modal>
    ` : null;
  }
}

